import { render, staticRenderFns } from "./GtButton.vue?vue&type=template&id=43965709&"
import script from "./GtButton.vue?vue&type=script&lang=ts&"
export * from "./GtButton.vue?vue&type=script&lang=ts&"
import style0 from "./GtButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports